import { PrinterDetailForm } from "../components/printers/PrinterDetailForm";
import { Section } from "../components/Section";

export function NewPrinterPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New printer</Section.Title>
      <PrinterDetailForm />
    </div>
  );
}
